export default {
    EGRESSO_DE_INTERNACAO: 33,
    CONVITE_PARA_ATIVIDADES_COLETIVAS_CAMPANHA_DE_SAUDE: 34,
    ORIENTACAO_PREVENCAO: 35,
    OUTROS: 36,
}